var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "18px", "font-weight": "600" } },
          [_vm._v("题库管理")]
        ),
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "danger",
                  size: "small",
                  icon: "el-icon-refresh-right",
                  loading: _vm.rebuildBinding
                },
                on: { click: _vm.handleRebuild }
              },
              [_vm._v(" 清空重绑 ")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "warning",
                  size: "small",
                  icon: "el-icon-refresh",
                  loading: _vm.allBinding
                },
                on: { click: _vm.handleAutoBindAll }
              },
              [_vm._v(" 一键全量绑定 ")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "success",
                  size: "small",
                  icon: "el-icon-magic-stick",
                  loading: _vm.batchBinding,
                  disabled: !_vm.selectedRows.length || _vm.batchBinding
                },
                on: { click: _vm.handleBatchAutoBind }
              },
              [
                _vm._v(" 批量自动绑定"),
                _vm.selectedRows.length
                  ? _c("span", [
                      _vm._v("（" + _vm._s(_vm.selectedRows.length) + "）")
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
                on: { click: _vm.handleCreate }
              },
              [_vm._v("新建题目")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "info",
                  size: "small",
                  icon: "el-icon-download"
                },
                on: { click: _vm.handleDownloadTemplate }
              },
              [_vm._v("模板下载")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-upload2",
                  loading: _vm.importing
                },
                on: { click: _vm.handleOpenImport }
              },
              [_vm._v("导入题目")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "搜索题目标题/内容",
                        clearable: ""
                      },
                      on: { clear: _vm.handleSearch },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearch($event)
                        }
                      },
                      model: {
                        value: _vm.query.keyword,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "keyword", $$v)
                        },
                        expression: "query.keyword"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.handleSearch },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "题型", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.questionTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "questionTypeId", $$v)
                        },
                        expression: "query.questionTypeId"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "单选", value: 1 } }),
                      _c("el-option", { attrs: { label: "连线", value: 2 } }),
                      _c("el-option", { attrs: { label: "排序", value: 3 } }),
                      _c("el-option", { attrs: { label: "简答", value: 4 } }),
                      _c("el-option", { attrs: { label: "长文本", value: 5 } }),
                      _c("el-option", { attrs: { label: "多选", value: 6 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "技能维度", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.skillDimension,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "skillDimension", $$v)
                        },
                        expression: "query.skillDimension"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "听力", value: "listening" }
                      }),
                      _c("el-option", {
                        attrs: { label: "阅读", value: "reading" }
                      }),
                      _c("el-option", {
                        attrs: { label: "看", value: "viewing" }
                      }),
                      _c("el-option", {
                        attrs: { label: "写作", value: "writing" }
                      }),
                      _c("el-option", {
                        attrs: { label: "综合", value: "comprehensive" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "难度", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.difficulty,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "difficulty", $$v)
                        },
                        expression: "query.difficulty"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "★ 基础", value: "★" }
                      }),
                      _c("el-option", {
                        attrs: { label: "★★ 提高", value: "★★" }
                      }),
                      _c("el-option", {
                        attrs: { label: "★★★ 拓展", value: "★★★" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "状态", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.status,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "草稿", value: "draft" }
                      }),
                      _c("el-option", {
                        attrs: { label: "已发布", value: "published" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "年级", clearable: "" },
                      on: { change: _vm.handleGradeFilterChange },
                      model: {
                        value: _vm.query.grade,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "grade", $$v)
                        },
                        expression: "query.grade"
                      }
                    },
                    _vm._l(_vm.gradeOptions, function(g) {
                      return _c("el-option", {
                        key: g.value,
                        attrs: { label: g.label, value: g.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "册别", clearable: "" },
                      on: { change: _vm.handleBookFilterChange },
                      model: {
                        value: _vm.query.book,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "book", $$v)
                        },
                        expression: "query.book"
                      }
                    },
                    _vm._l(_vm.bookOptions, function(b) {
                      return _c("el-option", {
                        key: b.value,
                        attrs: { label: b.label, value: b.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "单元",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.unit,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "unit", $$v)
                        },
                        expression: "query.unit"
                      }
                    },
                    _vm._l(_vm.unitFilterOptions, function(u) {
                      return _c("el-option", {
                        key: u.code,
                        attrs: { label: u.name, value: u.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "知识模块", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.module,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "module", $$v)
                        },
                        expression: "query.module"
                      }
                    },
                    _vm._l(_vm.moduleOptions, function(m) {
                      return _c("el-option", {
                        key: m.value,
                        attrs: { label: m.label, value: m.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "搜索选项内容（如 apple）",
                        clearable: ""
                      },
                      on: { clear: _vm.handleSearch },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearch($event)
                        }
                      },
                      model: {
                        value: _vm.query.choiceKeyword,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "choiceKeyword", $$v)
                        },
                        expression: "query.choiceKeyword"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.handleSearch },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 1,
                      controls: false,
                      placeholder: "题目ID",
                      clearable: ""
                    },
                    on: { change: _vm.handleSearch },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      }
                    },
                    model: {
                      value: _vm.query.id,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "id", $$v)
                      },
                      expression: "query.id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetFilter }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.pagination.total))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("总题目数")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#E6A23C" }
                    },
                    [_vm._v(_vm._s(_vm.statusCounts.draft || 0))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("草稿")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#67C23A" }
                    },
                    [_vm._v(_vm._s(_vm.statusCounts.published || 0))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("已发布")])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "", stripe: "" },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "60" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "标题",
                  "min-width": "180",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "question",
                  label: "题目内容",
                  "min-width": "200",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "questionTypeId", label: "题型", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", type: "info" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.questionTypeIdLabel(
                                  scope.row.questionTypeId
                                ) || "未设置"
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "skillDimension",
                  label: "技能维度",
                  width: "100"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: _vm.dimensionTagType(
                                scope.row.skillDimension
                              )
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dimensionLabel(scope.row.skillDimension)
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "bloomLevel", label: "布鲁姆", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", type: "warning" } },
                          [_vm._v(_vm._s(_vm.bloomLabel(scope.row.bloomLevel)))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "difficultyJson", label: "难度", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.difficultyLabel(scope.row.difficultyJson)
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: _vm.statusTagType(scope.row.status)
                            }
                          },
                          [_vm._v(_vm._s(_vm.statusLabel(scope.row.status)))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "knowledgePoints",
                  label: "知识点",
                  "min-width": "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.knowledgePoints &&
                        scope.row.knowledgePoints.length
                          ? _c(
                              "div",
                              _vm._l(scope.row.knowledgePoints, function(kp) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: kp.nodeId,
                                    staticStyle: {
                                      "margin-right": "4px",
                                      "margin-bottom": "2px",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      size: "small",
                                      type:
                                        kp.bindType === "primary"
                                          ? "primary"
                                          : "info"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.handleViewNodePath(
                                          scope.row,
                                          kp.nodeId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "block",
                                          "line-height": "1.3"
                                        }
                                      },
                                      [_vm._v(_vm._s(kp.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "block",
                                          "font-size": "10px",
                                          opacity: "0.65",
                                          "line-height": "1.2"
                                        }
                                      },
                                      [_vm._v(_vm._s(kp.nodeId))]
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          : _c("span", { staticClass: "text-muted" }, [
                              _vm._v("未绑定")
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "290", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-view"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleView(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-edit"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-link"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleBindNode(scope.row)
                              }
                            }
                          },
                          [_vm._v("知识点")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-share"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleViewPath(scope.row)
                              }
                            }
                          },
                          [_vm._v("路径")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-s-check"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleGoQc(scope.row)
                              }
                            }
                          },
                          [_vm._v("质检")]
                        ),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: { title: "确定删除该题目？" },
                            on: {
                              confirm: function($event) {
                                return _vm.handleDelete(scope.row)
                              }
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: {
                                  slot: "reference",
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-delete"
                                },
                                slot: "reference"
                              },
                              [_vm._v("删除")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "15px", "text-align": "right" },
            attrs: {
              background: "",
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              "page-sizes": [10, 20, 50, 100],
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "知识点关联 - " +
              (_vm.currentNodeQuestion.title || _vm.currentNodeQuestion.id),
            visible: _vm.nodeDialogVisible,
            width: "760px"
          },
          on: {
            "update:visible": function($event) {
              _vm.nodeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "bind-section" },
            [
              _c("div", { staticClass: "bind-title" }, [
                _vm._v("已绑定知识点")
              ]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.nodeLoading,
                      expression: "nodeLoading"
                    }
                  ],
                  attrs: { data: _vm.currentNodes, border: "", size: "small" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "nodeId", label: "知识点ID", width: "150" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "知识点名称",
                      "min-width": "140",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "bindType", label: "关联类型", width: "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v(_vm._s(scope.row.bindType))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "relevanceScore",
                      label: "关联度",
                      width: "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-share"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleViewSinglePath(scope.row)
                                  }
                                }
                              },
                              [_vm._v("路径")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleUnbindNode(scope.row)
                                  }
                                }
                              },
                              [_vm._v("解绑")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "bind-section" }, [
            _c("div", { staticClass: "bind-title" }, [
              _vm._v("按知识图谱路径绑定")
            ]),
            _c(
              "div",
              { staticClass: "bind-row" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "130px" },
                    attrs: { placeholder: "选择年级", size: "small" },
                    on: { change: _vm.handleGradeChange },
                    model: {
                      value: _vm.bindForm.grade,
                      callback: function($$v) {
                        _vm.$set(_vm.bindForm, "grade", $$v)
                      },
                      expression: "bindForm.grade"
                    }
                  },
                  _vm._l(_vm.gradeOptions, function(g) {
                    return _c("el-option", {
                      key: g.value,
                      attrs: { label: g.label, value: g.value }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "110px", "margin-left": "8px" },
                    attrs: { placeholder: "册别", size: "small" },
                    on: { change: _vm.handleBookChange },
                    model: {
                      value: _vm.bindForm.book,
                      callback: function($$v) {
                        _vm.$set(_vm.bindForm, "book", $$v)
                      },
                      expression: "bindForm.book"
                    }
                  },
                  _vm._l(_vm.bookOptions, function(b) {
                    return _c("el-option", {
                      key: b.value,
                      attrs: { label: b.label, value: b.value }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "180px", "margin-left": "8px" },
                    attrs: {
                      placeholder: "单元",
                      size: "small",
                      filterable: ""
                    },
                    on: { change: _vm.handleUnitChange },
                    model: {
                      value: _vm.bindForm.unit,
                      callback: function($$v) {
                        _vm.$set(_vm.bindForm, "unit", $$v)
                      },
                      expression: "bindForm.unit"
                    }
                  },
                  _vm._l(_vm.unitOptions, function(u) {
                    return _c("el-option", {
                      key: u.code,
                      attrs: { label: u.name, value: u.code }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "220px", "margin-left": "8px" },
                    attrs: {
                      placeholder: "知识点",
                      size: "small",
                      filterable: ""
                    },
                    model: {
                      value: _vm.bindForm.nodeId,
                      callback: function($$v) {
                        _vm.$set(_vm.bindForm, "nodeId", $$v)
                      },
                      expression: "bindForm.nodeId"
                    }
                  },
                  _vm._l(_vm.nodeOptions, function(n) {
                    return _c("el-option", {
                      key: n.id,
                      attrs: {
                        label: n.name + " (" + _vm.nodeTypeLabel(n.type) + ")",
                        value: n.id
                      }
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "8px" },
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: !_vm.bindForm.nodeId
                    },
                    on: { click: _vm.handleBindSelected }
                  },
                  [_vm._v("绑定选中")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "8px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      size: "small",
                      icon: "el-icon-magic-stick"
                    },
                    on: { click: _vm.handleAutoBind }
                  },
                  [_vm._v("按内容自动匹配绑定")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "知识点路径详情 - " +
              (_vm.pathQuestion.title || _vm.pathQuestion.id),
            visible: _vm.pathDialogVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.pathDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pathLoading,
                  expression: "pathLoading"
                }
              ],
              attrs: { data: _vm.pathDetails, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "知识点",
                  "min-width": "120",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v(_vm._s(scope.row.name))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "nodeType", label: "类型", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", type: "info" } },
                          [
                            _vm._v(
                              _vm._s(_vm.nodeTypeLabel(scope.row.nodeType))
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "bindType", label: "关联", width: "80" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "path",
                  label: "知识图谱路径",
                  "min-width": "260",
                  "show-overflow-tooltip": ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入题目",
            visible: _vm.importDialog.visible,
            width: "560px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.importDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-link",
                {
                  attrs: { type: "primary", icon: "el-icon-download" },
                  on: { click: _vm.handleDownloadTemplate }
                },
                [_vm._v("下载导入模板")]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#999",
                    "font-size": "12px"
                  }
                },
                [_vm._v("（模板带下拉验证，避免填错）")]
              )
            ],
            1
          ),
          _c(
            "el-upload",
            {
              ref: "uploadRef",
              attrs: {
                action: _vm.uploadAction,
                headers: _vm.uploadHeaders,
                name: "file",
                "auto-upload": false,
                limit: 1,
                accept: ".xlsx,.xls",
                "on-success": _vm.handleImportSuccess,
                "on-error": _vm.handleImportError,
                "before-upload": _vm.handleBeforeUpload,
                drag: ""
              }
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将 Excel 文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")])
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("只能上传 .xlsx/.xls 文件，单次最多 1000 条")]
              )
            ]
          ),
          _vm.importResult
            ? _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c("el-alert", {
                    attrs: {
                      title: _vm.importSummary,
                      type:
                        _vm.importResult.failedRows &&
                        _vm.importResult.failedRows.length
                          ? "warning"
                          : "success",
                      closable: false
                    }
                  }),
                  _vm.importResult.failedRows &&
                  _vm.importResult.failedRows.length
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "max-height": "200px",
                            "overflow-y": "auto"
                          }
                        },
                        _vm._l(_vm.importResult.failedRows, function(r) {
                          return _c(
                            "div",
                            {
                              key: r.rowNum,
                              staticStyle: {
                                color: "#F56C6C",
                                "font-size": "13px",
                                "line-height": "1.8"
                              }
                            },
                            [
                              _vm._v(
                                " 第 " +
                                  _vm._s(r.rowNum) +
                                  " 行：" +
                                  _vm._s(r.reason) +
                                  " "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.importDialog.visible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.importing },
                  on: { click: _vm.submitImport }
                },
                [_vm._v("开始导入")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }